/* tslint:disable:no-duplicate-string */

import { recommendationsPanelsLocaleKeys } from '@epicuro-next/constants/features/localization';
import {
  IDynamicItem,
  IDynamicSimpleText,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

import {
  createInstance,
  createInstanceWithChildren,
} from '../../../../utils/dynamic-items-utils';

import { dayRangeSelectOptions } from './day-range-select-options';
import { daysIntoTheFutureProvider } from './products-on-the-way-days-into-future-provider';
import { StoresDropdown } from './stores-dropdown-square-panel';

const simpleDayRangeSelect = createInstance({
  id: 'products-on-the-way-day-range-select',
  contentTypeId: 'dynamic-elements-simple-select',
  inputs: {
    options: dayRangeSelectOptions,
    selectedValue: {
      id: 'square-panel-root',
      property: 'selectedDayRange',
    },
  },
});

const inTheNextText: IDynamicSimpleText = {
  id: 'products-on-the-way-in-the-next-part-of-text',
  contentTypeId: 'dynamic-elements-simple-text',
  styles: {
    style: {
      'white-space': 'pre',
    },
    variables: {
      '--text-dynamic-color': 'var(--dark-mode-gray-600, #414141)',
    },
  },
  inputs: {
    text: recommendationsPanelsLocaleKeys.lookAhead,
  },
};

const nrOfDaysText: IDynamicSimpleText = {
  id: 'products-on-the-way-nr-of-days-text',
  contentTypeId: 'dynamic-elements-simple-text',
  styles: {
    style: {
      'text-decoration': 'underline',
    },
    classes: ['cursor-pointer'],
    variables: {
      '--text-dynamic-color': 'var(--dark-mode-gray-600, #414141)',
    },
  },
  inputs: {
    text: daysIntoTheFutureProvider,
  },
};

const dropdownForDaysPeriod: IDynamicItem = {
  contentTypeId: 'dynamic-elements-dropdown-wrapper',
  inputs: {
    triggerContent: nrOfDaysText,
    dropdownContent: simpleDayRangeSelect,
  },
};

const daysText: IDynamicSimpleText = {
  id: 'products-on-the-way-days-part-of-text',
  contentTypeId: 'dynamic-elements-simple-text',
  styles: {
    style: {
      'white-space': 'pre',
    },
    variables: {
      '--text-dynamic-color': 'var(--dark-mode-gray-600, #414141)',
    },
  },
  inputs: {
    text: ' days ',
  },
};

export const itemsInHeaderWrapper = createInstanceWithChildren({
  id: 'products-on-the-way-header-wrapper',
  contentTypeId: 'dynamic-collections-renderer',
  styles: {
    classes: ['d-flex', 'flex-column', 'h2', 'mb-0'],
  },
  children: [
    {
      contentTypeId: 'dynamic-collections-renderer',
      styles: {
        classes: ['d-flex', 'flex-row', 'justify-content-center'],
      },
      children: [
        inTheNextText,
        dropdownForDaysPeriod,
        daysText,
        StoresDropdown,
      ],
    },
  ],
});
